import * as React from 'react';
import { ShadowSquareWrapper } from './ShadowSquare_SC';

export interface Props {
  style: React.CSSProperties;
}

export const ShadowSquare: React.FC<Props> = (props) => {
  const { style } = props;
  return <ShadowSquareWrapper style={{ ...style }} />;
};
